export const AVISO_PRIVACIDAD_ROUTE = '/aviso-privacidad';
